export default __webpack_public_path__ + "static/media/meterreading-4.45c4762a.png";